import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, CheckCircle, Zap, Shield } from 'lucide-react';
function useRunningTotal() {
  const [total, setTotal] = useState(6.36);
  useEffect(() => {
    // Starts slow, accelerates as more "orders" come in
    let elapsed = 0;
    const tick = () => {
      elapsed += 1;
      // Accelerating increments: small at first, bigger over time
      const increment = Math.min(0.5 + elapsed * 0.08, 4.5);
      setTotal(prev => {
        const next = parseFloat((prev + increment).toFixed(2));
        return next >= 250 ? 250 : next;
      });
    };
    const id = setInterval(tick, 120);
    return () => clearInterval(id);
  }, []);
  return total;
}
export function HeroSection() {
  const runningTotal = useRunningTotal();
  return <section style={{
    background: 'linear-gradient(160deg, #FAFAF6 0%, #F2EDE4 55%, #E8DDD0 100%)',
    overflow: 'hidden'
  }} data-id="element-31">
      {/* Urgency bar */}
      <div style={{
      background: '#1C1C1E',
      padding: '11px 20px',
      textAlign: 'center'
    }} data-id="element-32">
        <p style={{
        fontFamily: "'Lato', sans-serif",
        fontSize: '13px',
        color: '#E8DDD0',
        margin: 0
      }} data-id="element-33">
          Esto no es para todas. Es para la mamá que ya está cansada de esperar
          que algo cambie.
        </p>
      </div>

      <div className="hero-layout" style={{
      maxWidth: '1100px',
      margin: '0 auto',
      padding: '36px 20px 60px'
    }} data-id="element-34">
        {/* IMAGE — first in DOM = first on mobile */}
        <motion.div className="hero-image" initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7
      }} style={{
        position: 'relative'
      }} data-id="element-35">
          <img src="https://cdn.magicpatterns.com/uploads/8Nv58TQVJ37zLdVQx57AUq/heylloyd-image-1771891824158.jpg" alt="Madre con sus hijos aprendiendo juntos en casa" style={{
          width: '100%',
          height: '380px',
          objectFit: 'cover',
          objectPosition: 'center 15%',
          borderRadius: '20px',
          boxShadow: '0 24px 60px rgba(28,28,30,0.18)',
          display: 'block'
        }} data-id="element-36" />
          <motion.div animate={{
          y: [0, -7, 0]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          background: '#fff',
          borderRadius: '14px',
          padding: '10px 14px',
          boxShadow: '0 6px 24px rgba(28,28,30,0.14)',
          border: '1px solid #E8DDD0'
        }} data-id="element-37">
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '9px',
            color: '#8A8A8A',
            margin: '0 0 2px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }} data-id="element-38">
              Ventas de hoy
            </p>
            <motion.p key={Math.floor(runningTotal)} initial={{
            y: -6,
            opacity: 0.4
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.1
          }} style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '18px',
            fontWeight: 900,
            color: '#1C1C1E',
            margin: 0
          }} data-id="element-39">
              +${runningTotal.toFixed(2)}
            </motion.p>
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '9px',
            color: '#1B5E3B',
            margin: 0,
            fontWeight: 700
          }} data-id="element-40">
              Mientras dormias
            </p>
          </motion.div>
          <motion.div animate={{
          y: [0, -7, 0]
        }} transition={{
          duration: 3.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.6
        }} style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          background: 'linear-gradient(135deg, #1B5E3B, #2D7A52)',
          borderRadius: '14px',
          padding: '10px 14px',
          boxShadow: '0 6px 20px rgba(27,94,59,0.35)',
          textAlign: 'center'
        }} data-id="element-41">
            <p style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '20px',
            fontWeight: 900,
            color: '#fff',
            margin: 0,
            lineHeight: 1
          }} data-id="element-42">
              $2,000
            </p>
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '9px',
            fontWeight: 700,
            color: 'rgba(255,255,255,0.8)',
            margin: 0,
            letterSpacing: '1px'
          }} data-id="element-43">
              AL MES
            </p>
          </motion.div>
        </motion.div>

        {/* COPY */}
        <div className="hero-copy" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: -8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} style={{
          marginBottom: '18px'
        }} data-id="element-45">
            <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            background: '#fff',
            border: '1px solid #E8DDD0',
            borderRadius: '100px',
            padding: '6px 14px',
            fontFamily: "'Lato', sans-serif",
            fontSize: '12px',
            fontWeight: 700,
            color: '#4A4A4A',
            boxShadow: '0 2px 10px rgba(28,28,30,0.07)'
          }} data-id="element-46">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} size={11} style={{
              color: '#C9973A',
              fill: '#C9973A'
            }} data-id="element-47" />)}
              &nbsp;+500 madres ya dieron el paso
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(26px, 5.5vw, 50px)',
          fontWeight: 900,
          color: '#1C1C1E',
          lineHeight: 1.18,
          margin: '0 0 16px'
        }} data-id="element-48">
            Ya es hora de que{' '}
            <span style={{
            color: '#1B5E3B',
            borderBottom: '3px solid #C9973A',
            paddingBottom: '2px'
          }} data-id="element-49">
              el dinero trabaje para ti,
            </span>{' '}
            no al revés.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.38
        }} style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: 'clamp(15px, 2.5vw, 17px)',
          color: '#4A4A4A',
          lineHeight: 1.8,
          margin: '0 0 20px'
        }} data-id="element-50">
            Descubre el sistema que miles de madres hispanas en EE.UU. están
            usando para generar{' '}
            <strong style={{
            color: '#1C1C1E'
          }} data-id="element-51">
              $1,000 a $2,000 al mes
            </strong>{' '}
            — sin dejar su trabajo, sin mostrar su cara, y sin que nadie sepa lo
            que están haciendo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.46
        }} style={{
          background: '#fff',
          borderLeft: '4px solid #1B5E3B',
          borderRadius: '0 12px 12px 0',
          padding: '16px 20px',
          marginBottom: '28px',
          boxShadow: '0 3px 14px rgba(28,28,30,0.07)'
        }} data-id="element-52">
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '15px',
            color: '#4A4A4A',
            lineHeight: 1.8,
            margin: 0,
            fontStyle: 'italic'
          }} data-id="element-53">
              "Son las 6:00 AM. El cuarto todavía está oscuro. Tus hijos
              duermen. Tú ya tienes que irte. Otro día que empieza igual.{' '}
              <strong style={{
              color: '#1C1C1E',
              fontStyle: 'normal'
            }} data-id="element-54">
                ¿Hasta cuándo vas a seguir cambiando tu tiempo por un cheque que
                nunca alcanza?
              </strong>
              "
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.54
        }} data-id="element-55">
            <a href="#precio" style={{
            textDecoration: 'none',
            display: 'block',
            marginBottom: '12px'
          }} data-id="element-56">
              <button className="cta-pulse" style={{
              background: 'linear-gradient(135deg, #1B5E3B, #2D7A52)',
              color: '#fff',
              fontFamily: "'Lato', sans-serif",
              fontWeight: 900,
              fontSize: 'clamp(14px, 2.5vw, 17px)',
              letterSpacing: '0.5px',
              padding: '17px 24px',
              borderRadius: '12px',
              border: '2px solid #C9973A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              width: '100%'
            }} data-id="element-57">
                QUIERO VER COMO FUNCIONA
                <ArrowRight size={17} data-id="element-58" />
              </button>
            </a>
            <div style={{
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }} data-id="element-59">
              {[{
              icon: <CheckCircle size={13} data-id="element-60" />,
              text: 'Solo $6.36'
            }, {
              icon: <Zap size={13} data-id="element-61" />,
              text: 'Acceso inmediato'
            }, {
              icon: <Shield size={13} data-id="element-62" />,
              text: 'Garantia 7 dias'
            }].map((item, i) => <span key={i} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontFamily: "'Lato', sans-serif",
              fontSize: '12px',
              color: '#4A4A4A'
            }} data-id="element-63">
                  <span style={{
                color: '#1B5E3B'
              }} data-id="element-64">
                    {item.icon}
                  </span>
                  {item.text}
                </span>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}